// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/large-screen2.less
// module id = 3229
// module chunks = 0